const richTextFragment = `
  json
  links {
    entries {
      block {
        __typename
        sys {
          id
        }
      }
    }
  }
`

export default richTextFragment
